import { render } from "./Various.vue?vue&type=template&id=221ecdaa"
import script from "./Various.vue?vue&type=script&lang=js"
export * from "./Various.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__